/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonAttachmentRGViewModel } from "../types/PersonAttachmentRGViewModel.ts";
import { eAnalysisStatusSchema } from "./eAnalysisStatusSchema.ts";

export const personAttachmentRGViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do registro de dados do RG.")),
  personAttachmentId: z.optional(
    z
      .number()
      .int()
      .describe("ID do anexo de pessoa ao qual este RG está vinculado."),
  ),
  personName: z
    .string()
    .describe("Nome da pessoa conforme consta no RG. Opcional.")
    .nullish(),
  rgNumber: z.string().describe("Número do RG. Opcional.").nullish(),
  cpfNumber: z
    .string()
    .describe("CPF conforme consta no RG. Opcional.")
    .nullish(),
  mothersName: z
    .string()
    .describe("Nome da mãe conforme consta no RG. Opcional.")
    .nullish(),
  fathersName: z
    .string()
    .describe("Nome do pai conforme consta no RG. Opcional.")
    .nullish(),
  shippingDate: z
    .string()
    .datetime()
    .describe("Data de expedição do RG. Opcional.")
    .nullish(),
  birthDate: z
    .string()
    .datetime()
    .describe("Data de nascimento conforme consta no RG. Opcional.")
    .nullish(),
  hasAnyInformation: z.optional(
    z
      .boolean()
      .describe(
        "Indica se ao menos um campo de informação do RG foi preenchido via OCR.",
      ),
  ),
  analysisStatus: z.optional(
    z
      .lazy(() => eAnalysisStatusSchema)
      .describe(
        "0 = Recognized | 1 = NotRecognized | 2 = SentToAnalysis | 3 = NotAnalyzed | ",
      ),
  ),
  analysisStatusText: z
    .string()
    .describe("Descrição textual do status da análise do OCR. Opcional.")
    .nullish(),
}) as unknown as ToZod<PersonAttachmentRGViewModel>;
